import { useEffect, useState } from "react";
import { Activity as ActIcon } from "lucide-react";
import api from "@/lib/api";

export default function ActivityLog() {
  const [acts, setActs] = useState([]);
  useEffect(() => { api.get("/admin/activity").then((r) => setActs(r.data)); }, []);

  return (
    <div className="max-w-3xl">
      <h1 className="font-heading text-2xl font-bold text-stone-800 mb-1">কার্যকলাপ লগ</h1>
      <p className="text-sm text-stone-500 mb-6">অ্যাডমিন কার্যক্রমের ইতিহাস</p>
      <div className="bg-white rounded-2xl border border-stone-200 divide-y divide-stone-100">
        {acts.length === 0 && <p className="p-6 text-stone-400 text-sm">কোনো কার্যকলাপ নেই।</p>}
        {acts.map((a) => (
          <div key={a.id} className="flex items-center gap-4 p-4">
            <span className="grid place-items-center h-9 w-9 rounded-full bg-stone-100 text-[var(--c-secondary)]"><ActIcon className="h-4 w-4" /></span>
            <div className="flex-1">
              <div className="text-sm text-stone-700"><span className="font-medium">{a.action}</span> — {a.target}</div>
              <div className="text-xs text-stone-400">{a.user} · {new Date(a.at).toLocaleString("bn-BD")}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
